import React, { useState, useEffect, useRef } from "react";
import {
  inputFormat,
  inputCustomFormat,
  msToTime,
  countDishes,
  billPlease,
  moneyFormat,
  getCurrentTimeInMs,
} from "../../ultil";
import _ from "lodash";
import moment from "moment";
import DetailStore from "../../components/StoreCart/DetailStore";
import Topping from "../../components/StoreCart/Topping";
import ListTopping from "../../components/StoreCart/ListTopping";
import InputCustom from "../../components/Input/InputCustom";
import TextTitle from "../../components/Text/TextTitle";
import TextTitle1 from "../../components/Text/TextTitle1";
import TextBody from "../../components/Text/TextBody";
import TextBody2 from "../../components/Text/TextBody2";
import TextHead from "../../components/Text/TextHead";
import TextPrice from "../../components/Text/TextPrice";
import TextPriceOld from "../../components/Text/TextPriceOld";
import TextQuantity from "../../components/Text/TextQuantity";
import TextOutOfStock from "../../components/Text/TextOutOfStock";
import SwipeableViews from 'react-swipeable-views';
import Modal from "react-modal";
import { modalStyleBottom, modalStyleDetail, style } from "../../style";
import { useTheme, styled } from '@mui/material/styles';
import {
  AppBar,
  Box,
  Divider,
  IconButton,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Tab,
  Tabs,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Grid,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const MTAMap = React.lazy(() =>
  import("../../components/MTAMap")
)
const noFunc = () => {}

const dayOfWeek = ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy']

export default function Content({
  infoStore,
  listStore,
  productType,
  setProductType,
  btnSearch,
  listFiter,
  filler,
  setDataDetail,
  grid,
  setAddCart,
  addCart,
  dataDetail,
  inputSearch,
  setLimit,
  limit,
  nameStore,
  orderType,
  user,
  discountMoneyStore,
  setIsCart,
  modalIsOpenTopping,
  setIsOpenTopping,
  isEditTopping,
  setIsEditTopping,
  indexEditTopping,
  setIndexEditTopping,
  isEditToppingInCart,
  setIsEditToppingInCart
}) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [offset, setOffset] = useState({});
  const [openDetail, setOpenDetail] = useState(false);
  const [getDay, setGetDay] = useState(0);
  const [toppingSelected, setToppingSelected] = useState([]);
  const [isOpenStoreDetail, setIsOpenStoreDetail] = useState(false)

  const [listTopping, setListTopping] = useState([]);
  const [modalIsOpenListTopping, setIsOpenListTopping] = useState(false);

  useEffect(() => {
    if (listStore.length != limit) {
      setLimit(listStore.length == 0 ? 10 : listStore.length);
    }
    const dateNow = new Date();
    setGetDay(dateNow.getDay());
  }, []);

  const btnGetID = (data) => {
    filler(data);
    setProductType(data);
    setIsOpen(true);
    setLimit(10);
  };
  const getDataDetailStore = data => {
    if (data.status !== 1 ||
    !infoStore.isOpen ||
    !data.isAvailable) {
        return
    }
    if (
      data.topping &&
      data.topping.length > 0
    ) {
      if (data.quantity > 0) {
        setIsOpenListTopping(true);
      } else {
        setIsOpenTopping(true);
      }
    } else {
      setOpenDetail(true);
    }
    setDataDetail(data);
    document.body.style.overflow = "hidden";
  };
  const closeModal = () => {
    setOpenDetail(false);
    document.body.style.overflow = "auto";
  };

  const btnAddToCard = data => {
    //neu co topping show chon topping
    if (data.topping && data.topping.length > 0) {
      if (data.quantity > 0 && countItem(data._id) > 0) {
        setIsOpenListTopping(true);
      } else {
        setIsOpenListTopping(false);
        setIsOpenTopping(true);
      }
      setDataDetail(data);
    } else {
      for (var i = 0; i < listStore.length; i++) {
        if (listStore[i]._id === data._id) {
          listStore[i].quantity = data.quantity + 1;
        }
      }
      if (addCart.length) {
        var index = _.findIndex(addCart, item => item._id === data._id);
        if (index !== -1) {
          addCart[index].quantity++;
        } else {
          addCart.push(data);
        }
      } else {
        addCart.push(data);
      }
      localStorage.setItem("list-carts", JSON.stringify(addCart));
      setAddCart(_.cloneDeep(addCart));
    }
  };
  const removeFromCart = data => {
    if (data.topping && data.topping.length > 0) {
      if (data.quantity > 0 && countItem(data._id) > 0) {
        setIsOpenListTopping(true);
      } else {
        setIsOpenListTopping(false);
        setIsOpenTopping(true);
      }
      setDataDetail(data);
    } else {
      for (var i = 0; i < listStore.length; i++) {
        if (listStore[i]._id === data._id) {
          listStore[i].quantity = data.quantity - 1;
        }
      }
      var index = _.findIndex(addCart, item => item._id === data._id);
      if (addCart[index].quantity > 1) {
        addCart[index].quantity--;
      } else {
        addCart.splice(index, 1);
      }
      localStorage.setItem("list-carts", JSON.stringify(addCart));
      setAddCart(_.cloneDeep(addCart));
    }
  };
  const backStore = () => {
    window.location.reload();
  };

  const countItem = id => {
    let count = 0;
    for (var i = 0; i < addCart.length; i++) {
      if (addCart[i]._id == id) {
        count += addCart[i].quantity;
      }
    }
    return count;
  };

  let productTypeIndex = listFiter.map(val=>val._id).indexOf(productType._id)
  productTypeIndex++
  return (
    <>
        <Box sx={{ position: 'relative', bgcolor: '#f0f0f0'}}>
        <Box onClick={()=>setIsOpenStoreDetail(true)} sx={{width: '100%'}}>
          <img src={infoStore.background ? infoStore.background : "image/store-01.png"} style={{position: 'static' ,zIndex: 100, width: '100%', height: 'auto'}}/>
          <Box sx={{ bgcolor: '#ffffff', padding: '16px'}} p={2}>
            {
              infoStore.isOpen && infoStore.status !== 0 ?
              <TextBody2 color="#04B18D"><i className="icon-verify" style={{color: '#04B18D'}}/> Đang mở cửa</TextBody2>
              :
              <TextBody2 color="#E93940"><i className="icon-clock" style={{color: '#E93940'}}/> Đang đóng cửa</TextBody2>
            }
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'start', cursor: 'pointer'}}>
              <TextTitle>
                {infoStore.name}
              </TextTitle>
              <IconButton>
                <ArrowForwardIosIcon/>
              </IconButton>
            </Box>
            <TextBody2 component="div">
              Địa chỉ: {infoStore.address}
            </TextBody2>
            {infoStore.totalOrders != 0 ? (
              <Box mt={1}>
                Cửa hàng đã bán: {infoStore.totalOrders}
              </Box>
            ) : null}
          </Box>
        </Box>
        <Box sx={{ bgcolor: '#ffffff', width: '100%' }} mt={1} pb={3}>
          <MenuTabs
            value={productTypeIndex <=0 ? 0 : productTypeIndex}
            onChange={(e, id)=>{
              btnGetID(listFiter[id-1] || " ")
            }}
            textColor="primary"
            variant="scrollable"
            scrollButtons
          >
            <MenuTab value={0} label="Tất Cả" {...a11yProps(0)} />
            {
              listFiter.length && listFiter.map((type, i)=><MenuTab value={i+1} key={type._id} label={type.name} {...a11yProps(i+1)}/>)
            }
          </MenuTabs>
          <SwipeableViews
            index={productTypeIndex}
            onChangeIndex={(id)=>{
              btnGetID(listFiter[id-1] || " ")
            }}
          >
            <TabPanel value={0} index={productTypeIndex} data={listStore}
              getDataDetailStore={getDataDetailStore}
              countItem={countItem}
              minusCart={removeFromCart}
              plusCart={btnAddToCard}
              isOpen={infoStore.isOpen && infoStore.status !== 0}
            />
            {
              listFiter.length ? listFiter.map((type, index)=>{
                return <TabPanel key={index} data={listStore} value={index+1} index={productTypeIndex}
                getDataDetailStore={getDataDetailStore}
                countItem={countItem}
                minusCart={removeFromCart}
                plusCart={btnAddToCard}
                isOpen={infoStore.isOpen && infoStore.status !== 0}
                />
              })
              : <div/>
            }
          </SwipeableViews>

        </Box>

        </Box>

        {modalIsOpenTopping && (
          <Modal
            isOpen={modalIsOpenTopping}
            style={modalStyleDetail}
            onRequestClose={()=>setIsOpenTopping(false)}
            ariaHideApp={false}
          >
            <Topping
              dataDetail={dataDetail}
              setDataDetail={setDataDetail}
              setAddCart={setAddCart}
              addCart={addCart}
              setIsOpenTopping={setIsOpenTopping}
              infoStore={infoStore}
              orderType={orderType}
              user={user}
              discountMoneyStore={discountMoneyStore}
              isEditTopping={isEditTopping}
              setIsEditTopping={setIsEditTopping}
              indexEditTopping={indexEditTopping}
              setIndexEditTopping={setIndexEditTopping}
              setIsCart={setIsCart}
              isEditToppingInCart={isEditToppingInCart}
              setIsEditToppingInCart={setIsEditToppingInCart}
            />
          </Modal>
        )}

        <Modal
          isOpen={modalIsOpenListTopping}
          style={modalStyleBottom}
          onRequestClose={()=>setIsOpenListTopping(false)}
          ariaHideApp={false}
        >
          <ListTopping
            dataDetail={dataDetail}
            setDataDetail={setDataDetail}
            setAddCart={setAddCart}
            addCart={addCart}
            setIsOpenListTopping={setIsOpenListTopping}
            setIsOpenTopping={setIsOpenTopping}
            infoStore={infoStore}
            orderType={orderType}
            user={user}
            discountMoneyStore={discountMoneyStore}
            isEditTopping={isEditTopping}
            setIsEditTopping={setIsEditTopping}
            indexEditTopping={indexEditTopping}
            setIndexEditTopping={setIndexEditTopping}
          />
        </Modal>

        {Object.values(dataDetail).length != 0 ? (
          <Modal
            isOpen={openDetail}
            style={modalStyleDetail}
            onRequestClose={closeModal}
            ariaHideApp={false}
          >
            <DetailStore
              dataDetail={dataDetail}
              setDataDetail={setDataDetail}
              setAddCart={setAddCart}
              addCart={addCart}
              setOpenDetail={setOpenDetail}
              infoStore={infoStore}
              orderType={orderType}
              user={user}
              discountMoneyStore={discountMoneyStore}
            />
          </Modal>
        ) : null}
        <StoreDetail open={isOpenStoreDetail} setOpen={setIsOpenStoreDetail} data={infoStore}/>
    </>
  );
}

const MenuItem = ({lastItem = false, isOpen, dataItem, quantity = 0, onClickAdd, onClickMinus, onClickItem}) => {
  const {_id, images, isAvailable, status, name, price, pricePromote, topping} = dataItem
  const disable = status !== 1 || !isOpen, outOfStock = !isAvailable, showPrice = pricePromote, oldPrice = price === pricePromote ? null : price
  let cartItem = {_id, quantity: 0}

  return <>
  <Box my={2} sx={{cursor: 'pointer'}} onClick={onClickItem}>
    <Box sx={{width: '100%', display: 'flex'}}>
      <Box>
        <ButtonBase sx={{width: 96, height: 96, borderRadius: '16px', position: 'relative' }}>
          <img src={images[0]} width="100%" height="100%" style={{borderRadius: '16px', filter: disable ? 'grayscale(1)': ''}}/>
          {outOfStock && <TextOutOfStock>Hết hàng</TextOutOfStock>}
        </ButtonBase>
      </Box>
      <Box pl={2} sx={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
        <TextBody className="line-clamp-2" gutterBottom>
          {name}
        </TextBody>
        <Box sx={{display: 'flex', alignItems: 'end'}}>
          <Box sx={{flexGrow: 1, display: 'flex', flexWrap: 'wrap-reverse', alignItems: 'end'}}>
            {
              showPrice && <TextPrice className="line-clamp-1" mr={1} component="div" color={disable ? "#7F8182" : "#1589D8"}>
                {moneyFormat(showPrice)}
              </TextPrice>
            }
            {
              oldPrice && <TextPriceOld className="line-clamp-1" component="div" color="#929394">
                {moneyFormat(oldPrice)}
              </TextPriceOld>
            }
          </Box>
          <Box>
            <ButtonGroup size="large" sx={{justifyContent: 'space-between', alignItems: 'end'}} variant="text" aria-label="text button group">
              {
                quantity > 0?
                <>
                <ButtonBase disabled={disable || outOfStock} onClick={(e)=>{
                  e.stopPropagation()
                  onClickMinus(1)
                }}>
                  <i className="icon-minus-square" style={{fontSize: '26px', color: disable ? '#7F8182' : '#b0bec5'}}/>
                </ButtonBase>
                <ButtonBase sx={{minWidth: '30px'}}>
                  <TextQuantity component="p">{quantity}</TextQuantity>
                </ButtonBase>
                </>
                :null
              }
              <ButtonBase disabled={disable || outOfStock} onClick={(e)=>{
                e.stopPropagation()
                onClickAdd(1)
              }}><i className="icon-add-square" style={{fontSize: '26px', color: disable ? '#7F8182' : '#1589D8'}}/></ButtonBase>
            </ButtonGroup>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
  {!lastItem && <Divider/>}
  </>
}

const TabPanel = ({ value, index, data, getDataDetailStore, countItem, minusCart, plusCart, isOpen,...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box px={2}>
        <Box mb={2}>
          <Box sx={{display: 'flex', flexDirection: 'column'}}>
          {
            !_.isEmpty(data) ?
            data.map((item, i)=><MenuItem
              key={i}
              lastItem={i === (data.length - 1)}
              dataItem={item}
              quantity={countItem(item._id)}
              onClickItem={()=>getDataDetailStore(item)}
              onClickAdd={()=>plusCart(item)}
              onClickMinus={()=>minusCart(item)}
              isOpen={isOpen}
            />)
            :
            <Box>
              <img
                style={{ width: "100%" }}
                src="/image/het-hang2.png"
              />
            </Box>
          }
          </Box>
        </Box>
        </Box>
      )}
    </div>
  );
}

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const MenuTabs = styled(Tabs)({
  borderBottom: '1px solid #EEF0F0',
  backgroundColor: '#ffffff',
  '& .MuiTabs-indicator': {
    backgroundColor: '#2f99e0',
  }
});

const MenuTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    padding: 10,

    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "140%",
    '&.Mui-selected': {
      color: '#1589D8',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(21, 137, 216, 1)',
    },
  }),
);

const StoreDetail = ({open, setOpen = ()=> {}, data}) => {
  const {name, isOpen, address, timeSettings, description, location} = data
  const handleClose = () => {
    setOpen(false)
  }
  const today = (new Date()).getDay(), currentTime = getCurrentTimeInMs()
  const storeLocation = {lat: _.get(location, 'coordinates[1]'), lng: _.get(location, 'coordinates[0]')}
  return (
    <Modal
      isOpen={open}
      style={modalStyleDetail}
      onRequestClose={handleClose}
      ariaHideApp={false}
    >
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Box sx={style}>
        <Box sx={{position: 'relative'}}>
          <AppBar
            position="sticky"
            color="inherit"
          >
            <Toolbar sx={{minHeight: '52px'}}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleClose}
              >
                <ArrowBackIcon fontSize="large"/>
              </IconButton>
              <TextTitle1 >
                Thông tin quán
              </TextTitle1>

            </Toolbar>
          </AppBar>
          <Box>
            <Box sx={{ bgcolor: '#ffffff', padding: '16px'}} p={2}>
            {
              isOpen && status !== 0 ?
              <TextBody2 color="#04B18D"><i className="icon-verify" style={{color: '#04B18D'}}/> Đang mở cửa</TextBody2>
              :
              <TextBody2 color="#E93940"><i className="icon-clock" style={{color: '#E93940'}}/> Đang đóng cửa</TextBody2>
            }
            <TextHead component="div">
              {name}
            </TextHead>
            <TextBody component="div">
              Địa chỉ:
            </TextBody>
            <TextBody2 component="div">
              {address}
            </TextBody2>
            {
              // <Box sx={{display: 'flex', justifyContent: 'start'}} mt={1}>
              //   <Box sx={{paddingRight: '10px'}}>
              //   <TextBody><i className="icon-location" style={{color: 'rgba(21, 137, 216, 1)'}}/> 0,19km</TextBody>
              //   </Box>
              //   <Divider orientation="vertical" flexItem/>
              //   <Box sx={{paddingLeft: '10px'}}>
              //   <TextBody><i className="icon-timer-1" style={{color: 'rgba(21, 137, 216, 1)'}}/> 20 phút</TextBody>
              //   </Box>
              // </Box>
            }

            <Box sx={{width: '100%', height: '200px'}} mt={1}>
            {
              storeLocation.lat ?
              <React.Suspense fallback={<div/>}>
              <MTAMap center={storeLocation} style={{borderRadius: '16px'}} markers={[{...storeLocation}]}/>
              </React.Suspense>
              :null
            }
            </Box>
            </Box>
          </Box>

          <Box mt={1} pb={2} sx={{bgcolor: '#ffffff'}}>
            <TextBody sx={{padding: '16px 16px 0px 16px'}}>
              GIỜ HOẠT ĐỘNG
            </TextBody>
            <Box mt={1}>
            {
              dayOfWeek.map((title, day)=><Box key={title} sx={{padding: '5px 16px', bgcolor: today === day ? 'rgba(21, 137, 216, 0.1)' : ''}}>
              <Grid container spacing={1}>
                <Grid item sx={{display: 'flex', alignItems: 'center'}}>
                  <i className="icon-note" style={{fontSize: '20px', color: '#929394'}}/>
                </Grid>
                <Grid item xs container>
                <Grid item xs={3} sx={{display: 'flex', alignItems: 'center', minWidth: '80px'}}>
                <TextBody color="#929394">
                  {title}:
                </TextBody>
                </Grid>
                <Grid item xs sx={{display: 'flex', alignItems: 'center'}}>
                <TextBody color="#929394">
                  {
                  timeSettings && timeSettings[day] ?
                    timeSettings[day].map(({startTime, endTime})=>`${msToTime(startTime)} - ${msToTime(endTime)}`).join(', ')
                    : "Đóng cửa"
                  }
                </TextBody>
                </Grid>
                </Grid>
              </Grid>
              </Box>
            )
            }

            </Box>
          </Box>

          <Box mt={1} sx={{bgcolor: '#ffffff', padding: '16px'}}>
            <TextBody>
              MÔ TẢ CỬA HÀNG
            </TextBody>
            <TextBody2>
              {description || 'Không có mô tả'}
            </TextBody2>
          </Box>
        </Box>
      </Box>
      </Slide>
      </Modal>
  );
};
